import { render } from "./Invitations.vue?vue&type=template&id=7cced1d7&scoped=true&bindings={\"invitations\":\"data\",\"getInvitationText\":\"options\",\"getInvitations\":\"options\",\"postInvitation\":\"options\"}"
import script from "./Invitations.vue?vue&type=script&lang=js"
export * from "./Invitations.vue?vue&type=script&lang=js"

import "./Invitations.vue?vue&type=style&index=0&id=7cced1d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7cced1d7"

export default script